import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import {useTranslation} from 'react-i18next';
import {DndWrapper} from 'components/DndWrapper';
import {Dropzone} from 'components/Dropzone';
import {FormShell} from 'components/form/FormShell';
import {ImageContainer} from 'components/ui/ImageContainer';
import {observer} from 'mobx-react-lite';
import {VehicleState} from 'store/vehicle/VehicleState';

interface VehiclePhotosProps {
  state: VehicleState;
}

export const VehiclePhotos: React.FC<VehiclePhotosProps> = observer(({state}): JSX.Element => {
  const {t} = useTranslation();
  const images = state.item.photos;

  return (
    <FormShell isLoading={state.isLoading}>
      <div>
        <Dropzone
          accept={{
            'image/jpeg': [],
            'image/png': [],
          }}
          multiple={true}
          onDrop={(acceptedFiles: File[]) => state.updatePhotoFiles(acceptedFiles)}
        />
        <p className="text-darkGray mt-2">
          {t('The first photo is a main photo. Drag and drop photos to rearrange them.')}
        </p>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <DndProvider backend={HTML5Backend}>
            {images &&
              images.photoFiles &&
              images.photoFiles.map((image, idx) => (
                <DndWrapper
                  key={idx}
                  index={idx}
                  id={idx}
                  onMove={(dragIndex, hoverIndex) => state.updateImages(dragIndex, hoverIndex)}
                  onDrop={() => state.updateImagesPost()}
                >
                  <ImageContainer image={image} onRemove={() => state.removePhotoFile(image.fileId)} />
                </DndWrapper>
              ))}
          </DndProvider>
        </div>
      </div>
    </FormShell>
  );
});
